import { render, staticRenderFns } from "./CollectionImageCarouselIndex.vue?vue&type=template&id=cbc7c0ae&scoped=true&"
import script from "./CollectionImageCarouselIndex.vue?vue&type=script&lang=js&"
export * from "./CollectionImageCarouselIndex.vue?vue&type=script&lang=js&"
import style0 from "./CollectionImageCarouselIndex.vue?vue&type=style&index=0&id=cbc7c0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc7c0ae",
  null
  
)

export default component.exports